import React from "react";
import SignupForm from "../../components/auth-forms/signup-form/SignupForm";

export default function SignupPage() {
  return (
    <div>
      <SignupForm />
    </div>
  );
}
